import type { ISpread } from "../../spreadsSlice";

export const oneCardSpread: ISpread = {
  id: "spread_one_card",
  name: "Одна карта",
  altNames: ["One-Card Draw"],
  purpose: "Быстрая диагностика состояния, ключевая подсказка или совет",
  cardsCount: 1,
  layout: "[1]",
  positions: [
    {
      id: "focus",
      title: "Ключевой аспект",
      meaning: "Суть вопроса, главный урок или наиболее важный аспект сейчас",
    },
  ],
  symbolism: "Архетип целостности: ситуация в моменте сводится к одной доминанте",
  archetypes: ["Единица", "Монолит", "Центр осознания"],
  psychology: "Фокусирует внимание, помогает убрать «шум» и сосредоточиться на главном",
  procedure: {
    preparation: "Сконцентрироваться на вопросе или теме",
    steps: "Перетасовать колоду с намерением получить ясный сигнал и выложить одну карту; читать её строго в контексте вопроса",
  },
  interpretations: [
    "Сила — необходимость проявлять терпение и уверенность",
    "Жрица — прислушаться к интуиции",
    "5 Мечей — риск/угроза конфликта",
  ],
  nuances: [
    "Не перегружать одну карту множеством трактовок",
    "Дать время первому ощущению от карты",
    "Если карта кажется «не в тему», это может быть признак сопротивления",
  ],
  examples: [
    {
      cards: ["Повешенный"],
      interpretation: "День паузы и переосмысления",
    },
    {
      cards: ["Справедливость"],
      interpretation: "Замедлиться, опереться на факты и баланс",
    },
  ],
  selfQuestions: [
    "Какая энергия сейчас преобладает?",
    "Что важно осознать в этой ситуации?",
    "Какова моя первая реакция на карту?",
  ],
};


